export default "__VITE_ASSET__0856b13a__"